import { defineComponent as _defineComponent } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'codeInput',
  props: {
  title: {
    type: String,
    default: '示例',
  },
  content: {
    type: String,
    default: '',
  },
  width: {
    type: String,
    default: '488px',
  },
  rows: {
    type: String,
    default: '6',
  },
},
  emits: ['update:content'],
  setup(__props, { emit }) {

const props = __props




function handleChangeValue(event: any) {
  emit('update:content', event.target.value)
}

return { __sfc: true,props, emit, handleChangeValue }
}

})